import { render } from "./MvTab.vue?vue&type=template&id=2af6098f&ts=true"
import script from "./MvTab.vue?vue&type=script&lang=ts"
export * from "./MvTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__